(function () {
  "use strict";

  function resolveBadgeType(input) {
    if (!input || typeof input !== "object") return "";

    if (input.isSoldOut) return "sold-out";
    if (input.isLowStock) return "low-stock";
    if (input.isBestSeller) return "best-seller";
    if (input.hasHoheNachfrage) return "hohe-nachfrage";
    if (input.hasBio) return "bio";

    return "";
  }

  window.PeakBadges = window.PeakBadges || {};
  window.PeakBadges.resolveBadgeType = resolveBadgeType;
})();
